import { render, staticRenderFns } from "./EditHeaderItemModal.vue?vue&type=template&id=554bdf82&"
import script from "./EditHeaderItemModal.vue?vue&type=script&lang=js&"
export * from "./EditHeaderItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports